import { VERNACULAR_DEFAULT_MESSAGES } from "constants/vernacularConstants";


interface ValidationReturnType{ error: string, hasError: boolean };

export const validateGiftCardNumberField = (value:string|null, errors?: {required: string, invalid: string}): ValidationReturnType => {
  let error = "";
  let hasError = false;
  if (!value) {
    error = errors?.required || VERNACULAR_DEFAULT_MESSAGES.REQUIRED;
    hasError = true;
  } else if (value?.toString()?.length < 16) {
    // show error if giftcard number is less than 16 digits
    error = "Enter valid gift card number";
    hasError = true;
  }
  else {
    error = "";
  }

  return {
    error,
    hasError,
  };
};
